/*
 * Copyright (c) 2020.
 * Simon
 */

import {DOMAIN_NOTIFY_EMAIL_DETAIL_SUCCESS, DOMAIN_NOTIFY_EMAIL_LIST_SUCCESS} from "../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const DomainNotifyEmailsReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case DOMAIN_NOTIFY_EMAIL_LIST_SUCCESS:
            let notifies = action.payload.data.data;

            notifies.map((notify) => {
                let id = notify['_id'];
                if (notify.notify_type === 'collection') {
                    notify.email = 'encrypted'
                }
                state[id] = notify;
                return true;
            });

            return {...state, action};

        case DOMAIN_NOTIFY_EMAIL_DETAIL_SUCCESS:
            let id = action.payload.data['id'];
            state[id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {DomainNotifyEmailsReducer}